import { render, staticRenderFns } from "./donor-auction-campaigns-popover.vue?vue&type=template&id=41ecc872&"
import script from "./donor-auction-campaigns-popover.vue?vue&type=script&setup=true&lang=js&"
export * from "./donor-auction-campaigns-popover.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports